// extracted by mini-css-extract-plugin
module.exports = {"breakdown":"style_breakdown__bAWxy","row":"style_row__dbnzf"};